const LINKS = {
  404: '/404/',
  500: '/500/',
  APP_DOWNLOAD: 'https://promobit.onelink.me/OPOZ/g38ldz5y',
  BADGES_AND_LEVELS: `https://${process.env.NEXT_PUBLIC_SUBDOMAIN}.promobit.com.br/profile/medalhas-e-niveis/`,
  BLACK_FRIDAY: '/black-friday/',
  BLOG: '/blog/',
  BUSINESS: `/comercial/parcerias/`,
  CHRISTMAS: '/promocoes-do-ano/campanhanatal/',
  COMMUNITY_GUIDELINES: '/institucional/diretrizes-da-comunidade/',
  COOKIES_POLICY: `/institucional/cookies/`,
  COUPONS: '/cupons/',
  DELETE_ACCOUNT: '/configuracoes/exclusao-de-conta/',
  FAQ: `/institucional/faq/`,
  FATHERS_DAY: '/promocoes-do-ano/diadospais/',
  FORUM: '/forum/',
  HAPPY_NEW_YEAR: '/promocoes-do-ano/ano-novo-tudo-novo/',
  HOME: '/',
  IDINHEIRO: 'https://www.idinheiro.com.br/',
  LANDING_APPS: `https://${process.env.NEXT_PUBLIC_SUBDOMAIN}.promobit.com.br/ofertas/app-ofertas/`,
  LOW_PRICE_OFFERS: '/promocoes/menor-preco/',
  MELHOR_PLANO: 'https://melhorplano.net',
  MELIUZ: 'https://www.meliuz.com.br/',
  MESSAGES: `https://${process.env.NEXT_PUBLIC_SUBDOMAIN}.promobit.com.br/central/mensagens/`,
  MINHA_CONEXAO: 'https://www.minhaconexao.com.br/',
  MOTHERS_DAY: '/promocoes-do-ano/dia-das-maes/',
  MUAMBATOR: 'https://www.muambator.com.br/',
  MY_OFFERS: '/minhas-ofertas/',
  NEW_COUPON: `/cupons/novo-cupom/`,
  NEW_OFFER: `/promocoes/nova-oferta/`,
  NEW_THREAD: `/forum/novo-topico/`,
  NOTIFICATIONS: '/notificacoes/',
  PRIME_DAY: '/promocoes-do-ano/prime-day/',
  PROMOBIT_COUPONS: '/cupons/promobit/',
  PROMOBIT_WHAT_IS: `https://${process.env.NEXT_PUBLIC_SUBDOMAIN}.promobit.com.br/o-que-e-promobit/`,
  PURCHASE_ISSUES: `/institucional/compra-segura/`,
  RECENT_OFFERS: '/promocoes/recentes/',
  SEARCH: '/buscar/',
  SETTINGS: '/configuracoes/',
  SITEMAP: '/mapa-site/',
  STORES: '/lojas/',
  TREND_OFFERS: '/promocoes/em-alta/',
  WISHLIST: '/lista-de-desejos/',
};

export default LINKS;
